




































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ICompany } from "../../companies/api/company.interface";
import ConfirmDialog from "@/shared/ConfirmDialog.vue";

@Component({
  name: "companyTable",
  components: {
    ConfirmDialog
  }
})
export default class CompanyTable extends Vue {
  @Prop()
  companies: ICompany[];

  $refs: {
    confirm: any;
  };

  companyHeaders: any[] = [
    {
      text: "Company",
      align: "left",
      sortable: true,
      value: "name"
    },
    {
      text: "Quickbooks File",
      align: "center",
      sortable: "false",
      value: "qbDesktopPath"
    },
    {
      text: "Actions",
      align: "center",
      sortable: false,
      value: "name"
    }
  ];

  mounted() {}

  deleteCompany(company: ICompany) {
    this.$refs.confirm
      .open(
        "Are you sure?",
        // tslint:disable-next-line:max-line-length
        "Deleting this company will not affect the companies associated stores",
        {
          color: "red"
        }
      )
      .then((confirm: boolean) => {
        if (confirm) {
          this.$store.dispatch("admin/deleteCompany", company.id);
        }
      });
  }
}
